module.exports = __webpack_public_path__ + "img/doc-default-icon.af22800b.png";